import axios from 'axios';

export const baseRequest = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL,
  headers: {
    'Content-Type': 'multipart/form-data'
  },
  withCredentials: true,
  timeout: 30 * 1000,
});
